import React, { useEffect } from 'react';
import styled from 'styled-components';
import { ReactSortable } from 'react-sortablejs';
import { Container, Stack, Button, reset, buttonReset, FormGroup, Label, Input, Select, Toolbar, Modal, Panel, PanelTitle, Handle, PanelContent, H } from '@raketa-cms/raketa-mir';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
var WidgetContext = React.createContext();
var rand = function rand(length) {
  return Math.random().toString(36).substring(length);
};
var remove = function remove(items, item) {
  var idx = items.findIndex(function (i) {
    return i.id === item.id;
  });
  return [].concat(items.slice(0, idx), items.slice(idx + 1));
};
var update = function update(items, item) {
  var idx = items.findIndex(function (i) {
    return i.id === item.id;
  });
  return [].concat(items.slice(0, idx), [item], items.slice(idx + 1));
};
var append = function append(items, item) {
  return [].concat(items, [item]);
};
var Factories = {
  item: function item() {
    return {
      id: rand(4),
      label: 'New item',
      url: '#',
      target: '',
      rows: []
    };
  },
  row: function row() {
    return {
      id: rand(4),
      columns: []
    };
  },
  column: function column() {
    return {
      id: rand(4),
      widgets: []
    };
  },
  widget: function widget(component, settings) {
    return {
      id: rand(4),
      component: component,
      settings: settings
    };
  }
};
var _templateObject, _templateObject2;
var Item = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  display: inline-flex;\n  align-items: center;\n  padding: 0;\n  margin-right: 0.5em;\n  border: 1px solid\n    ", ";\n  border-radius: 48px;\n  background-color: ", ";\n  font-weight: 700;\n  transition: 0.1s ease-in-out all;\n\n  &:hover {\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n  }\n"])), reset, function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.gray;
}, function (props) {
  return props.active ? props.theme.colors.primary : props.theme.colors.white;
});
var TabButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  ", ";\n  padding: 0.5em 1em;\n  color: ", ";\n  font-weight: 700;\n"])), buttonReset, function (props) {
  return props.active ? props.theme.colors.white : props.theme.colors.black;
});
var MainNavigation = function (_ref) {
  var items = _ref.items,
    tab = _ref.tab,
    onTab = _ref.onTab,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Container, {
    bottom: true
  }, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(ReactSortable, {
    list: items,
    setList: onChange,
    direction: "horizontal",
    dragoverBubble: true
  }, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Item, {
      key: item.id,
      active: idx === tab
    }, /*#__PURE__*/React.createElement(TabButton, {
      type: "button",
      active: idx === tab,
      onClick: function onClick() {
        return onTab(idx);
      }
    }, item.label));
  })), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      return onChange(append(items, Factories.item()));
    }
  }, "Add item")));
};
var _templateObject$1, _templateObject2$1, _templateObject3, _templateObject4, _templateObject5;
var Icon = styled.span(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n  line-height: 1;\n  filter: invert(", ");\n"])), function (props) {
  return props.invert ? 1 : 0;
});
var Edit = styled(Icon)(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWVkaXQtMiI+PHBhdGggZD0iTTE3IDNhMi44MjggMi44MjggMCAxIDEgNCA0TDcuNSAyMC41IDIgMjJsMS41LTUuNUwxNyAzeiI+PC9wYXRoPjwvc3ZnPg==);\n"])));
var Delete = styled(Icon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXRyYXNoIj48cG9seWxpbmUgcG9pbnRzPSIzIDYgNSA2IDIxIDYiPjwvcG9seWxpbmU+PHBhdGggZD0iTTE5IDZ2MTRhMiAyIDAgMCAxLTIgMkg3YTIgMiAwIDAgMS0yLTJWNm0zIDBWNGEyIDIgMCAwIDEgMi0yaDRhMiAyIDAgMCAxIDIgMnYyIj48L3BhdGg+PC9zdmc+);\n"])));
var Plus = styled(Icon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXBsdXMiPjxsaW5lIHgxPSIxMiIgeTE9IjUiIHgyPSIxMiIgeTI9IjE5Ij48L2xpbmU+PGxpbmUgeDE9IjUiIHkxPSIxMiIgeDI9IjE5IiB5Mj0iMTIiPjwvbGluZT48L3N2Zz4=);\n"])));
var Copy = styled(Icon)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWNvcHkiPjxyZWN0IHg9IjkiIHk9IjkiIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMyIgcng9IjIiIHJ5PSIyIj48L3JlY3Q+PHBhdGggZD0iTTUgMTVINGEyIDIgMCAwIDEtMi0yVjRhMiAyIDAgMCAxIDItMmg5YTIgMiAwIDAgMSAyIDJ2MSI+PC9wYXRoPjwvc3ZnPg==);\n"])));
var ItemForm = function (_ref) {
  var item = _ref.item,
    _onChange = _ref.onChange,
    onRemove = _ref.onRemove,
    onDuplicate = _ref.onDuplicate;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "label"
  }, "Label"), /*#__PURE__*/React.createElement(Input, {
    name: "label",
    type: "text",
    wrapperProps: {
      style: {
        marginRight: '0.5em'
      }
    },
    value: item.label,
    onChange: function onChange(e) {
      return _onChange(_extends({}, item, {
        label: e.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "url"
  }, "URL"), /*#__PURE__*/React.createElement(Input, {
    name: "url",
    type: "text",
    value: item.url,
    onChange: function onChange(e) {
      return _onChange(_extends({}, item, {
        url: e.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "target"
  }, "Target"), /*#__PURE__*/React.createElement(Select, {
    name: "target",
    value: item.target,
    onChange: function onChange(e) {
      return _onChange(_extends({}, item, {
        target: e.target.value
      }));
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Please select"), /*#__PURE__*/React.createElement("option", {
    value: "_self"
  }, "Open in same tab"), /*#__PURE__*/React.createElement("option", {
    value: "_blank"
  }, "Open in new tab")))), /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Stack, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onDuplicate
  }, /*#__PURE__*/React.createElement(Copy, null)), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(Delete, null)))));
};
var AdminWidget = function (_ref) {
  var Component = _ref.Component,
    settings = _ref.settings,
    onChange = _ref.onChange,
    onCancel = _ref.onCancel;
  var _React$useState = React.useState(settings),
    state = _React$useState[0],
    setState = _React$useState[1];
  var Form = Component.admin;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Form, {
    settings: state,
    onChange: function onChange(key, value) {
      var _extends2;
      setState(_extends({}, state, (_extends2 = {}, _extends2[key] = value, _extends2)));
    }
  }), /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    variant: "primary",
    onClick: function onClick() {
      return onChange(_extends({}, state));
    }
  }, "Save"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: onCancel
  }, "Cancel"));
};
var _templateObject$2;
var WidgetButton = styled.button(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  ", ";\n  width: 100%;\n  margin-bottom: 0.5em;\n  padding: 1em;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  font-weight: 500;\n  text-align: left;\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n    color: ", ";\n  }\n"])), buttonReset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.primaryLight;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
});
var AddWidget = function (_ref) {
  var onAdd = _ref.onAdd,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(Modal, {
    open: true,
    title: "Select widget",
    onClose: onClose
  }, /*#__PURE__*/React.createElement(WidgetContext.Consumer, null, function (WIDGETS) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, Object.keys(WIDGETS).map(function (widgetName) {
      return /*#__PURE__*/React.createElement(WidgetButton, {
        key: widgetName,
        onClick: function onClick() {
          return onAdd(widgetName, WIDGETS[widgetName]);
        }
      }, widgetName);
    }));
  }));
};
var getWidget = function getWidget(widgets, name) {
  return widgets[name];
};
var getTitle = function getTitle(widgets, widget) {
  var component = widget.component;
  var primaryField = getWidget(widgets, component).primaryField;
  return primaryField ? component + ": " + widget.settings[primaryField] : component;
};
var ContentBuilder = function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var _React$useState = React.useState({
      open: false,
      current: null
    }),
    widget = _React$useState[0],
    setWidget = _React$useState[1];
  var _React$useState2 = React.useState(false),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var _React$useState3 = React.useState(value),
    state = _React$useState3[0],
    setState = _React$useState3[1];
  useEffect(function () {
    setState(value);
  }, [value]);
  var addWidget = function addWidget(items, item) {
    var newState = _extends({}, state, {
      widgets: [].concat(items, [item])
    });
    setOpen(false);
    setState(newState);
    onChange(newState);
  };
  var removeWidget = function removeWidget(items, item) {
    if (!confirm('Are you sure?')) return;
    var newState = _extends({}, state, {
      widgets: remove(items, item)
    });
    setState(newState);
    onChange(newState);
  };
  var reorder = function reorder(widgets) {
    var newState = _extends({}, state, {
      widgets: widgets
    });
    setState(newState);
    onChange(newState);
  };
  var closeWidget = function closeWidget() {
    return setWidget({
      open: false,
      current: null
    });
  };
  var updateWidget = function updateWidget(widget, settings) {
    var newState = _extends({}, state, {
      widgets: update(state.widgets, _extends({}, widget, {
        settings: settings
      }))
    });
    closeWidget();
    setState(newState);
    onChange(newState);
  };
  return /*#__PURE__*/React.createElement(WidgetContext.Consumer, null, function (WIDGETS) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactSortable, {
      list: state.widgets,
      setList: function setList(widgets) {
        return reorder(widgets);
      },
      handle: ".r-handle",
      direction: "vertical"
    }, state.widgets.map(function (widget) {
      return /*#__PURE__*/React.createElement(Panel, {
        key: widget.id
      }, /*#__PURE__*/React.createElement(PanelTitle, null, /*#__PURE__*/React.createElement(Stack, {
        v: "center"
      }, /*#__PURE__*/React.createElement(Handle, {
        className: "r-handle"
      }), getTitle(WIDGETS, widget)), /*#__PURE__*/React.createElement(Stack, {
        v: "center"
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "secondary",
        onClick: function onClick() {
          return setWidget({
            open: true,
            current: widget
          });
        }
      }, /*#__PURE__*/React.createElement(Edit, null)), /*#__PURE__*/React.createElement(Button, {
        variant: "secondary",
        onClick: function onClick() {
          return removeWidget(state.widgets, widget);
        }
      }, /*#__PURE__*/React.createElement(Delete, null)))));
    })), /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return setOpen(true);
      }
    }, "Add widget"), widget.open && /*#__PURE__*/React.createElement(Modal, {
      title: "Settings",
      open: widget.open,
      onClose: closeWidget
    }, /*#__PURE__*/React.createElement(AdminWidget, {
      Component: getWidget(WIDGETS, widget.current.component),
      settings: widget.current.settings,
      onChange: function onChange(settings) {
        return updateWidget(widget.current, settings);
      },
      onCancel: closeWidget
    })), open && /*#__PURE__*/React.createElement(AddWidget, {
      onAdd: function onAdd(component, widget) {
        return addWidget(state.widgets, Factories.widget(component, widget.defaults));
      },
      onClose: function onClose() {
        return setOpen(false);
      }
    }));
  });
};
var _templateObject$3;
var Wrapper = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  .r-list {\n    display: flex;\n  }\n"])));
var ColumnBuilder = function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var _React$useState = React.useState(value),
    state = _React$useState[0],
    setState = _React$useState[1];
  useEffect(function () {
    setState(value);
  }, [value]);
  var addColumn = function addColumn(items, item) {
    var newState = _extends({}, state, {
      columns: [].concat(items, [item])
    });
    setState(newState);
    onChange(newState);
  };
  var updateColumn = function updateColumn(items, item) {
    var newState = _extends({}, state, {
      columns: update(items, item)
    });
    setState(newState);
    onChange(newState);
  };
  var duplicateColumn = function duplicateColumn(items, item) {
    var newState = _extends({}, state, {
      columns: append(items, _extends({}, item, {
        id: rand(),
        label: item.label + " (copy)"
      }))
    });
    setState(newState);
  };
  var removeColumn = function removeColumn(items, item) {
    if (!confirm('Are you sure?')) return;
    var newState = _extends({}, state, {
      columns: remove(items, item)
    });
    setState(newState);
    onChange(newState);
  };
  var reorder = function reorder(columns) {
    var newState = _extends({}, state, {
      columns: columns
    });
    setState(newState);
    onChange(newState);
  };
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      return addColumn(state.columns, Factories.column());
    }
  }, "Add column")), /*#__PURE__*/React.createElement(ReactSortable, {
    list: state.columns,
    setList: function setList(columns) {
      return reorder(columns);
    },
    className: "r-list",
    handle: ".r-chandle",
    direction: "vertical"
  }, state.columns.map(function (column, idx) {
    return /*#__PURE__*/React.createElement(Panel, {
      key: column.id,
      style: {
        flex: 1,
        marginRight: '0.5em'
      }
    }, /*#__PURE__*/React.createElement(PanelTitle, null, /*#__PURE__*/React.createElement(Stack, {
      v: "center"
    }, /*#__PURE__*/React.createElement(Handle, {
      className: "r-chandle"
    }), "Column #", idx + 1), /*#__PURE__*/React.createElement(Stack, {
      v: "center"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return duplicateColumn(state.columns, column);
      }
    }, /*#__PURE__*/React.createElement(Copy, null)), /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return removeColumn(state.columns, column);
      }
    }, /*#__PURE__*/React.createElement(Delete, null)))), /*#__PURE__*/React.createElement(PanelContent, null, /*#__PURE__*/React.createElement(ContentBuilder, {
      value: column,
      onChange: function onChange(column) {
        return updateColumn(state.columns, column);
      }
    })));
  })));
};
var RowBuilder = function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var _React$useState = React.useState(value),
    state = _React$useState[0],
    setState = _React$useState[1];
  useEffect(function () {
    setState(value);
  }, [value]);
  var addRow = function addRow(items, item) {
    var newState = _extends({}, state, {
      rows: [].concat(items, [item])
    });
    setState(newState);
    onChange(newState);
  };
  var updateRow = function updateRow(items, item) {
    var newState = _extends({}, state, {
      rows: update(items, item)
    });
    setState(newState);
    onChange(newState);
  };
  var removeRow = function removeRow(items, item) {
    if (!confirm('Are you sure?')) return;
    var newState = _extends({}, state, {
      rows: remove(items, item)
    });
    setState(newState);
    onChange(newState);
  };
  var reorder = function reorder(rows) {
    var newState = _extends({}, state, {
      rows: rows
    });
    setState(newState);
    onChange(newState);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactSortable, {
    list: state.rows,
    setList: function setList(rows) {
      return reorder(rows);
    },
    handle: ".r-handle",
    direction: "vertical"
  }, state.rows.map(function (row, idx) {
    return /*#__PURE__*/React.createElement(Panel, {
      key: row.id
    }, /*#__PURE__*/React.createElement(PanelTitle, null, /*#__PURE__*/React.createElement(Stack, {
      v: "center"
    }, /*#__PURE__*/React.createElement(Handle, {
      className: "r-handle"
    }), "Row #", idx + 1), /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: function onClick() {
        return removeRow(state.rows, row);
      }
    }, /*#__PURE__*/React.createElement(Delete, null))), /*#__PURE__*/React.createElement(PanelContent, null, /*#__PURE__*/React.createElement(ColumnBuilder, {
      value: row,
      onChange: function onChange(row) {
        return updateRow(state.rows, row);
      }
    })));
  })), /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      return addRow(state.rows, Factories.row());
    }
  }, "Add row")));
};
var index = function (_ref) {
  var widgets = _ref.widgets,
    value = _ref.value,
    onChange = _ref.onChange;
  var _React$useState = React.useState(value),
    state = _React$useState[0],
    setState = _React$useState[1];
  var currentTab = state.tab;
  var currentItem = state.items ? state.items[currentTab] : null;
  var removeItem = function removeItem(items, item) {
    if (!confirm('Are you sure?')) return;
    var newState = _extends({}, state, {
      tab: 0,
      items: remove(items, item)
    });
    setState(newState);
    if (onChange) onChange(newState);
  };
  var updateItem = function updateItem(items, item) {
    var newState = _extends({}, state, {
      items: update(items, item)
    });
    setState(newState);
    if (onChange) onChange(newState);
  };
  var duplicateItem = function duplicateItem(items, item) {
    var newState = _extends({}, state, {
      items: append(items, _extends({}, item, {
        id: rand(),
        label: item.label + " (copy)"
      }))
    });
    setState(newState);
    if (onChange) onChange(newState);
  };
  return /*#__PURE__*/React.createElement(WidgetContext.Provider, {
    value: widgets
  }, /*#__PURE__*/React.createElement(MainNavigation, {
    items: state.items,
    tab: currentTab,
    onTab: function onTab(tab) {
      return setState(_extends({}, state, {
        tab: tab
      }));
    },
    onChange: function onChange(items) {
      return setState(_extends({}, state, {
        items: items
      }));
    }
  }), currentItem && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ItemForm, {
    item: currentItem,
    onChange: function onChange(item) {
      updateItem(state.items, _extends({}, currentItem, item));
    },
    onRemove: function onRemove() {
      return removeItem(state.items, currentItem);
    },
    onDuplicate: function onDuplicate() {
      return duplicateItem(state.items, currentItem);
    }
  }), /*#__PURE__*/React.createElement(H, {
    as: "h4",
    size: "large"
  }, "Menu content"), /*#__PURE__*/React.createElement(RowBuilder, {
    value: currentItem,
    onChange: function onChange(item) {
      return updateItem(state.items, _extends({}, currentItem, item));
    }
  })));
};
export { index as MenuBuilder };